import React from 'react';
import { Spinner } from '../utils/Spinner'
import { useSpinner } from '../../../hooks/useSpinner'

export const BotonProcesar = (props) => {
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();

    return (
        <button 
            {...props}
            onClick={async () => {
                mostrarSpinner()
                await props.onClick()
                ocultarSpinner()
            }}
        >
            <Spinner spinner={spinner.toString()}></Spinner>
            <i className={`bg-[#336fbb] px-4 py-1 text-xl rounded hover:bg-[#155bb5] lg:text-[20px] lg:px-3 lg:py-0 fas fa-angle-right ${props.spinner === 'true' && 'ml-2'}`}></i>
        </button>
    )
}
